import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="shared--reset-form"
export default class extends Controller {
  connect() {
    this.handleSubmitEnd = (e) => e.target.reset()
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }
}
